/* eslint-disable @typescript-eslint/no-explicit-any */
const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d / 2
  if (t < 1) {
    return (c / 2) * t * t + b
  }
  t--
  return (-c / 2) * (t * (t - 2) - 1) + b
}

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
const requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    (window as any).webkitRequestAnimationFrame ||
    (window as any).mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )
})()

// because it's so fucking difficult to detect the scrolling element, just move them all
const move = (amount: number) => {
  document.documentElement.scrollTop = amount
  ;(document.body.parentNode as HTMLElement).scrollTop = amount
  document.body.scrollTop = amount
}

function moveX(amount: number) {
  document.documentElement.scrollLeft = amount
  ;(document.body.parentNode as HTMLElement).scrollLeft = amount
  document.body.scrollLeft = amount
}

function position() {
  return (
    document.documentElement.scrollTop ||
    (document.body.parentNode as HTMLElement).scrollTop ||
    document.body.scrollTop
  )
}

function positionX() {
  return (
    document.documentElement.scrollLeft ||
    (document.body.parentNode as HTMLElement).scrollLeft ||
    document.body.scrollLeft
  )
}

// 垂直方向滚动
export function scrollTo(to: number, duration?: number, callback?: () => void) {
  const start = position()
  const change = to - start
  const increment = 20
  let currentTime = 0
  duration = typeof duration === 'undefined' ? 500 : duration
  const animateScroll = () => {
    // increment the time
    currentTime += increment
    // find the value with the quadratic in-out easing function
    const val = easeInOutQuad(currentTime, start, change, duration as number)
    // move the document.body
    move(val)
    // do the animation unless its over
    if (currentTime < (duration as number)) {
      requestAnimFrame(animateScroll)
    } else {
      if (callback && typeof callback === 'function') {
        // the animation is done so lets callback
        callback()
      }
    }
  }
  animateScroll()
}

// 水平方向滚动
export function scrollToX(to: number, duration?: number, callback?: () => void) {
  const start = positionX()
  const change = to - start
  const increment = 20
  let currentTime = 0
  duration = typeof duration === 'undefined' ? 500 : duration
  const animateScrollX = () => {
    // increment the time
    currentTime += increment
    // find the value with the quadratic in-out easing function
    const val = easeInOutQuad(currentTime, start, change, duration as number)
    // move the document.body
    moveX(val)
    // do the animation unless its over
    if (currentTime < (duration as number)) {
      requestAnimFrame(animateScrollX)
    } else {
      if (callback && typeof callback === 'function') {
        // the animation is done so lets callback
        callback()
      }
    }
  }
  animateScrollX()
}
